import { render, staticRenderFns } from "./LastTaskButton.vue?vue&type=template&id=afe1e7fe&"
import script from "./LastTaskButton.vue?vue&type=script&lang=js&"
export * from "./LastTaskButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports